import { Chip, MenuItem, TextField } from "@mui/material"

const cores = { Ativo: "success", "Stand-by": "warning", Manutenção: "error" }

export function SituacaoChip({ situacao }) {
  return <Chip component="span" size="small" label={situacao || "NÃO INFORMADA"} color={Object.hasOwn(cores,situacao) ? cores[situacao] : "default"}
    sx={situacao === "Stand-by" ? { bgcolor: "#facc15", color: "#422006" } : undefined} />
}

export default function Situacao({ todas = false, ...props }) {
  return <TextField {...props} select InputLabelProps={todas ? { ...props.InputLabelProps, shrink: true } : props.InputLabelProps} SelectProps={{ displayEmpty:true, ...props.SelectProps, renderValue: valor => todas && !valor ? "Todas" : <SituacaoChip situacao={valor} /> }}>
    {todas && <MenuItem value="">Todas</MenuItem>}
    {props.value && !Object.hasOwn(cores,props.value) && <MenuItem value={props.value} disabled><SituacaoChip situacao={props.value} /> (ORIGINAL)</MenuItem>}
    {Object.keys(cores).map(s => <MenuItem key={s} value={s}><SituacaoChip situacao={s} /></MenuItem>)}
  </TextField>
}
